import * as React from "react";

const LayeredLevels = (props: { color?: string }): JSX.Element => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_27_2230)">
            <path
                d="M8.55315 1.45331C8.37944 1.37407 8.19074 1.33307 7.99981 1.33307C7.80889 1.33307 7.62019 1.37407 7.44648 1.45331L1.73315 4.05331C1.61485 4.10547 1.51427 4.19091 1.44366 4.29921C1.37304 4.40752 1.33545 4.53402 1.33545 4.66331C1.33545 4.7926 1.37304 4.9191 1.44366 5.0274C1.51427 5.13571 1.61485 5.22114 1.73315 5.27331L7.45315 7.87997C7.62686 7.95921 7.81555 8.00021 8.00648 8.00021C8.19741 8.00021 8.38611 7.95921 8.55981 7.87997L14.2798 5.27997C14.3981 5.22781 14.4987 5.14237 14.5693 5.03407C14.6399 4.92576 14.6775 4.79926 14.6775 4.66997C14.6775 4.54068 14.6399 4.41418 14.5693 4.30588C14.4987 4.19757 14.3981 4.11214 14.2798 4.05997L8.55315 1.45331Z"
                stroke={props.color ?? "currentColor"}
                strokeWidth="1.33333"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.3335 8C1.33318 8.12751 1.36944 8.25244 1.43798 8.35997C1.50651 8.46749 1.60444 8.55311 1.72016 8.60667L7.4535 11.2133C7.6263 11.2916 7.81381 11.3321 8.0035 11.3321C8.19319 11.3321 8.3807 11.2916 8.5535 11.2133L14.2735 8.61333C14.3915 8.56029 14.4915 8.47406 14.5614 8.36516C14.6312 8.25625 14.6679 8.12937 14.6668 8"
                stroke={props.color ?? "currentColor"}
                strokeWidth="1.33333"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.3335 11.3333C1.33318 11.4608 1.36944 11.5858 1.43798 11.6933C1.50651 11.8008 1.60444 11.8864 1.72016 11.94L7.4535 14.5466C7.6263 14.6249 7.81381 14.6654 8.0035 14.6654C8.19319 14.6654 8.3807 14.6249 8.5535 14.5466L14.2735 11.9466C14.3915 11.8936 14.4915 11.8074 14.5614 11.6985C14.6312 11.5896 14.6679 11.4627 14.6668 11.3333"
                stroke={props.color ?? "currentColor"}
                strokeWidth="1.33333"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_27_2230">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default LayeredLevels;
